export default __webpack_public_path__ + "static/media/415.acdd55be.gif";